module.exports = __webpack_public_path__ + "static/media/7.24.1c53bb41.png";